import { render, staticRenderFns } from "./CategoryBurgerMenu.vue?vue&type=template&id=833f192a&scoped=true&"
import script from "./CategoryBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBurgerMenu.vue?vue&type=style&index=0&id=833f192a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833f192a",
  null
  
)

export default component.exports